import {Directive, Input} from "@angular/core";
import {FormControl, NG_VALIDATORS, Validator, ValidatorFn} from "@angular/forms";
import {UIFormEngineComponentMetadata} from "./form";

@Directive({
    selector: 'input[inputNumberValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: UIInputNumberComponentValidator,
            multi: true
        }
    ]
})
export class UIInputNumberComponentValidator implements Validator {
    @Input() inputNumberValidator: UIFormEngineComponentMetadata;
    validator: ValidatorFn;

    constructor() {
        this.validator = this.numberValidator();
    }

    validate(c: FormControl) {
        return this.validator(c);
    }

    numberValidator(): ValidatorFn {
        // console.log('numberValidator', this.inputNumberValidator);
        return (c: FormControl) => {
            if (c.value === null)
                return null;
            let decimalsAllowed = this.inputNumberValidator.options && this.inputNumberValidator.options['decimals'] ? this.inputNumberValidator.options['decimals'] : 0;
            let re = new RegExp('^[0-9\'\,]*\\.?[0-9]{0,' + decimalsAllowed + '}$', 'g');
            let isValid = re.test(c.value);
            // console.error('numberValidator', c.value, re, isValid ? 'isValid' : 'error');
            if (isValid) {
                return null;
            } else {
                return {
                    number: 'not a valid number, ' + decimalsAllowed + ' decimals allowed'
                };
            }
        }
    }
}
